<template>
  <div class="home">
    <div class="box">
      <div class="box-left">
        <div class="pro">
          <div class="title">审批类</div>
          <el-row :gutter="20">
            <el-col
              v-for="(item, index) in appList"
              :key="index"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="6"
              v-if="item.isShow"
            >
              <div class="back" :style="{'background': item.img}" @click="turn(item)">
                <div style="margin-top:45px">{{item.label}}</div>
                <div style="font-size: 30px" v-if="item.badge">{{item.badge}}</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="pro">
          <div class="title">项目类</div>
          <el-row :gutter="16" style="display: flex;align-items: center;">
            <el-col
              v-for="(item, index) in proList"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              style="margin-bottom: 5px;"
            >
              <div v-if="!item.split" class="grid-content" @click="turn(item)">
                <div class="grid-left">
                  <div :class="item.class">
                    <i :class="item.icon"></i>
                  </div>
                  <b>{{ item.label }}</b>
                </div>
                <div class="grid-right" :style="item.badge ? 'color: #0c75e5' : 'color: #282828'" v-if="item.badge">{{item.badge}}</div>
              </div>
              <div v-else class="grid-content">
                <div class="grid-left">
                  <div :class="item.class">
                    <i :class="item.icon"></i>
                  </div>
                  <div style="display: flex;flex-direction: column;font-size: 18px;">
                    <div v-for="(name,index) in item.labels" :key="name">
                      <div style="display: flex;flex-direction: row;align-items: center;cursor: pointer;" @click="turn2(item, index)">
                        <b>{{name}}</b>
                        <div class="grid-right2" :style="item.badges[index] ? 'color: #0c75e5' : 'color: #282828'" v-if="item.badges[index]">{{item.badges[index]}}</div>
                      </div>
                      <el-divider v-if="index < item.labels.length - 1"></el-divider>
                    </div>
                  </div>
                </div>
              </div>

            </el-col>
          </el-row>
        </div>
      </div>
      <div class="box-right pro">
        <div class="box-top">
          <div>
            <img style="width: 50px" src="@/assets/images/touxiang.png" alt="">
          </div>
          <div>
            <div style="font-family: 黑体">您好，{{loginUser?.bussName}}</div>
            <div style="font-size:12px;margin-top:8px">欢迎进入工作台，开始一天的工作吧</div>
          </div>
        </div>
        <div class="box-bottom">
          <div style="display:flex;justify-content: space-between;">
            <div class="title">我的消息</div>
            <div style="color: #999;font-size: 14px" @click="goMessage">查看更多</div>
          </div>

          <div class="message" v-for="(item, index) in msgList" :key="index" @click="viewMore(item)" style="">
            <div class="left">
              <div class="title1" :style="item.status == '1' ? 'color: #999999' : 'color: #333333'">{{item.msgTitle}}</div>
              <div class="time">{{item.createTime | filter_handleDateTime}}</div>
            </div>
            <div class="right">
              <DictTag :options="dropDown.msgType" :value="item.msgType" :isStyle="true"/>
            </div>
            <div class="dot" v-if="item.status == '0'"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pro" v-if="cfDboardContList.length">
      <div class="title">数据分析</div>
      <div class="main">
        <div class="box" v-for="(item, index) in cfDboardContList" :key="index" style="width: 49%">
          <div class="tit">
            <span>{{ item.name }}</span>
            <p></p>
          </div>
          <!-- 柱状 -->
          <div v-if="item.type == '1'">
            <div :id="'echart' + index" class="echart" style="height: 250px"></div>
          </div>
          <!-- 折线 -->
          <div v-if="item.type == '2'">
            <div :id="'echart' + index" class="echart" style="height: 250px"></div>
          </div>
          <!-- 饼图 -->
          <div v-if="item.type == '4'">
            <div :id="'echart' + index" class="echart" style="height: 250px"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 审批类 -->
    <!-- <div class="pro">

      <el-row :gutter="16">
        <el-col
          v-for="(item, index) in appList"
          :key="index"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          v-if="item.isShow"
        >
          <div class="grid-content" @click="turn(item)">
            <div class="grid-left">
              <div :class="item.class">
                <i :class="item.icon"></i>
              </div>
              <b>{{item.label}}</b>
            </div>
            <div class="grid-right" :style="item.badge ? 'color: #0c75e5' : 'color: #282828'" v-if="item.badge">{{item.badge}}</div>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <!-- 项目类 -->
    <!-- <div class="pro">

    </div> -->
    <!-- 个人类 -->
    <!-- <div class="pro" v-if="ofoFlowDealList.length">
      <div class="title">个人类</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in ofoFlowDealList" :key="index" :label="item.name" :name="String(item.ofoDealId)">
          <el-row :gutter="16">
            <el-col
              v-for="(val, id) in ofoFlowWorkList"
              :key="id"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
            >
              <div class="grid-content" style="cursor:pointer" @click="turnWork(item, val)">
                <div class="grid-left">
                  <div class="icon icon7">
                    <i class="iconfont icon-daiban"></i>
                  </div>
                  <span style="font-size:18px">{{val.name}}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div> -->
    <!-- <div class="pro" v-if="manList[0].isShow">
      <div class="title">管理类</div>
      <el-row :gutter="16">
        <el-col
          v-for="(item, index) in manList"
          :key="index"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"

        >
          <div class="grid-content" @click="turn(item)">
            <div class="grid-left">
              <div :class="item.class">
                <i :class="item.icon"></i>
              </div>
              <b>{{item.label}}</b>
            </div>
            <div class="grid-right" :style="item.badge ? 'color: #0c75e5' : 'color: #282828'">{{item.badge}}</div>
          </div>

        </el-col>
      </el-row>
    </div> -->
    <!-- <div class="pro" v-if="mineList[0].isShow">
      <div class="title">个人类</div>
      <el-row :gutter="16">
        <el-col
          v-for="(item, index) in mineList"
          :key="index"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"

        >
          <div class="grid-content" @click="turn(item)">
            <div class="grid-left">
              <div :class="item.class">
                <i :class="item.icon"></i>
              </div>
              <b>{{item.label}}</b>
            </div>
            <div class="grid-right" :style="item.badge ? 'color: #0c75e5' : 'color: #282828'">{{item.badge}}</div>
          </div>

        </el-col>
      </el-row>
    </div> -->
    <!-- <div class="echarts">
      <div class="item">
        <div class="title">数据统计</div>
        <statsCharts />
      </div>
      <div class="item">
        <div class="title">季度报表分析</div>
        <analyseCharts />
      </div>
    </div> -->
    <el-dialog v-dialog-drag  title="修改密码" :visible.sync="dialogFormVisible"
      :append-to-body="true" width="30%">
      <div style="color:red;font-size:14px;margin-bottom:15px">当前密码强度较弱，请修改密码</div>
      <el-form ref="form" :model="userForm" :rules="rules" label-width="80px">
        <el-form-item label="旧密码" prop="password">
          <el-input v-model="userForm.password" placeholder="请输入旧密码" type="password" show-password/>
        </el-form-item>
        <el-form-item label="新密码" prop="password1">
          <el-input v-model="userForm.password1" placeholder="请输入新密码" type="password" show-password/>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input v-model="userForm.password2" placeholder="请确认确认密码" type="password" show-password/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import statsCharts from '@/components/echarts/stats.vue'
import analyseCharts from '@/components/echarts/analyse.vue'
import url from '@/config/url'
import DictTag from '@/components/DictTag.vue'
import { mapState } from 'vuex'
import qs from 'qs'
import * as echarts from "echarts";
  export default {
    name: 'home',
    components: {
      statsCharts,
      analyseCharts,
      DictTag
    },
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      })
    },
    data() {
      const equalToPassword = (rule, value, callback) => {
        if (this.userForm.password1 !== value) {
          callback(new Error("两次输入的密码不一致"));
        } else {
          callback();
        }
      };
      return {
        appList: [
          {
            label: '待我审批',
            path: '/process',
            name: 'approval',
            badge: null,
            class: 'icon icon1',
            icon: 'iconfont icon-daiban',
            children: [],
            isShow: true,
            appstatus: '3',
            img: 'url(' + require('@/assets/images/daiwoshenpi.png')+') no-repeat'

          },
          {
            label: '完成审批',
            path: '/process',
            badge: null,
            name: 'done',
            class: 'icon icon4',
            icon: 'iconfont icon-yiwancheng-yiban-02',
            children: [],
            isShow: true,
            appstatus: '1',
            img: 'url(' + require('@/assets/images/wanchengshenpi.png')+') no-repeat'
          },
          {
            label: '我发起的',
            path: '/process',
            name: 'mine',
            badge: null,
            class: 'icon icon2',
            icon: 'iconfont icon-wofaqide1',
            children: [],
            isShow: true,
            appstatus: '99',
            img: 'url(' + require('@/assets/images/wofaqide.png')+') no-repeat'
          },
          {
            label: '抄送给我',
            path: '/process',
            name: 'copy',
            badge: null,
            class: 'icon icon3',
            icon: 'iconfont icon-ziyuan200',
            children: [],
            isShow: true,
            appstatus: '9',
            img: 'url(' + require('@/assets/images/chaosong.png')+') no-repeat'
          },

        ],
        proList: [
          {
            label: '我的收藏',
            path: '/collect',
            badge: null,
            name: 'collect',
            class: 'icon icon8',
            icon: 'iconfont icon-hanhan-01-01',
            children: []
          },
          {
            split: true,
            labels: ['分享给我', '我的分享'],
            badges: [0, 0],
            names: ['share', 'myShare'],
            paths: ['/share', '/myShare'],
            class: 'icon icon7',
            icon: 'iconfont icon-fenxianggeiwo',
            children: []
          },
          {
            label: '预警消息',
            // path: '/share',
            badge: 0,
            name: 'warn',
            class: 'icon icon5',
            icon: 'iconfont icon-yujing',
            children: []
          },
          {
            label: '我的置顶',
            path: '/project',
            badge: 0,
            name: 'top',
            class: 'icon icon1',
            icon: 'iconfont icon-zhidingmian',
            children: []
          },
        ],
        manList: [
          {
            label: '管理中心',
            path: '/manage',
            badge: null,
            name: 'manage',
            class: 'icon icon8',
            icon: 'iconfont icon-guanlizhongxin',
            children: [],
            isShow: false
          },
        ],
        mineList: [
          {
            label: '个人中心',
            path: '/mine',
            badge: null,
            name: 'mine',
            class: 'icon icon8',
            icon: 'iconfont icon-gerenzhongxin2',
            children: [],
            isShow: false
          },
        ],
        menuList: JSON.parse(sessionStorage.getItem('menuList')),
        loginUser: {bussName: ''},
        activeName: '',
        ofoFlowDealList: [],
        ofoFlowWorkList: [],
        dialogFormVisible: false,
        userForm: {
          password: '',
          password1: '',
          password2: ''
        },
        // 表单校验
        rules: {
          password: [
            { required: true, message: "旧密码不能为空", trigger: "blur" }
          ],
          password1: [
            { required: true, message: "新密码不能为空", trigger: "blur" },
            { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" }
          ],
          password2: [
            { required: true, message: "确认密码不能为空", trigger: "blur" },
            { required: true, validator: equalToPassword, trigger: "blur" }
          ]
        },
        msgList: [],
        cfDboardContList: []
      }
    },
    created () {
      // this.$http.get(url.getWorkResAndThingList, {params: {
      //   ofoWorkId: 840,
      //   pageNum: 1,
      //   pageSize: 10,
      //   type: '1'
      // }}).then(res => {
      //   if(res.data.code == 200) {
      //     // this.$handleTree(res.data.data.list, 'bomId', 'pid')
      //     console.log(this.$handleTree(res.data.data.list, 'bomId', 'pid'))
      //   }
      // })
      this.getFlowMenuList()
      // this.$eventBus.$off('editShareStatus')
      // this.$eventBus.$on('editShareStatus', val => {
      //   console.log(val);
      // })
      // this.loginUser = JSON.parse(sessionStorage.getItem('loginUser'))
      this.$http.get(url.getLoginUser).then(res => {
        this.loginUser = res.data.data
      })
      this.$http.get(url.getIndexCount).then(res => {
        if(res.data.code == 200) {
          this.appList.forEach(item => {
            item.badge = res.data.data[item.name]
          })
          this.proList.forEach(item => {
            if(item.split) {
              item.labels.forEach((name, index) => {
                item.badges[index] = res.data.data[item.names[index]]
              })
            }else{
              item.badge = res.data.data[item.name]
            }
          })
        }
      })
      // 获取消息列表
      this.$http.get(url.getMsgList, {params: {
        // msgType: this.formInline.msgType,
        // status: this.formInline.status,
        pageNum: 1,
        pageSize: 3
      }}).then(res => {
        this.msgList = res.data.data.list
      })
      this.init()
    },
    updated () {
      this.menuList = JSON.parse(sessionStorage.getItem('menuList'))
      this.menuList.forEach(item => {
        if(item.menuType == '1'){ // 管理类
          this.manList[0].isShow = true
        }else if(item.menuType == '2') { // 个人类
          this.mineList[0].isShow = true
        }
      })
    },
    methods: {
      init() {
        this.$http.get(url.getCfDboard).then(res => {
          if(res.data.code == 200) {
            this.cfDboardContList = res.data.data.cfDboardContList
            if(this.cfDboardContList.some(item => item.dataSourceType == 'rept')) {
              this.cfDboardContList = this.cfDboardContList.filter(item => item.type != '3').slice(0, 2)
              if(this.cfDboardContList.length) {
                this.getCfOrgReptList()
              }

            }
          }
        })
      },
      async getCfOrgReptList() {
        await this.$http.get(url.getCfOrgReptList).then(res => {
          if(res.data.code == 200) {
            let orgReptList = res.data.data
            this.cfDboardContList.forEach((item, index) => {
              // if(item.dataSourceType == 'rept') {
              let orgRept = orgReptList.find(val => val.cfFlowReptId == item.cforgreptId)
              item.orgRept = orgRept
              item.flowRepttype = orgRept.flowRepttype
              item.cfFlowReptcontList = orgRept.cfFlowReptcontList
              if(item.type == '1') {
                if(orgRept.flowRepttype == '1' || orgRept.flowRepttype == '2') {
                  this.$http.get(url.getOrgRept, {params: {
                    cfFlowReptId: item.cforgreptId,
                  }}).then(res => {
                    if(res.data.code == 200) {
                      let xAxis = res.data.data.map(item => item.name)
                      let series = orgRept.cfFlowReptcontList.map(val => {
                        return {
                          ...val,
                          data: this.getData(val, res.data.data),
                          type: 'bar',
                          name: val.label,
                          // label: labelOption,
                          emphasis: {
                            focus: 'series'
                          },
                        }
                      })
                      this.echarts_1(xAxis, series, 'echart' + index)
                    }
                  })
                }else {
                  let xAxis = ['活动一', '活动二', '活动三', '活动四', '活动五', '活动六', '活动七']
                  let series = [
                    {
                      data: [120, 200, 150, 80, 70, 110, 130],
                      type: 'bar'
                    }
                  ]
                  this.echarts_1(xAxis, series, 'echart' + index)
                }
              }else if(item.type == '2') {
                if(orgRept.flowRepttype == '1' || orgRept.flowRepttype == '2') {
                  this.$http.get(url.getOrgRept, {params: {
                    cfFlowReptId: item.cforgreptId,
                  }}).then(res => {
                    if(res.data.code == 200) {
                      let xAxis = res.data.data.map(item => item.name)
                      let series = orgRept.cfFlowReptcontList.map(val => {
                        return {
                          ...val,
                          name: val.label,
                          type: 'line',
                          data: this.getData(val, res.data.data),
                          symbol: "none"
                        }
                      })
                      this.echarts_2(xAxis, series, 'echart' + index)
                    }
                  })
                }else{
                  let xAxis = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                  let series = [
                    {
                      name: '电脑',
                      type: 'line',
                      // stack: 'Total',
                      data: [120, 132, 101, 134, 90, 230, 210],
                      symbol: "none"
                    },
                    {
                      name: '鼠标',
                      type: 'line',
                      // stack: 'Total',
                      data: [15, 182, 191, 234, 290, 330, 500],
                      symbol: "none"
                    },
                    {
                      name: '键盘',
                      type: 'line',
                      // stack: 'Total',
                      data: [330, 232, 201, 154, 190, 330, 410],
                      symbol: "none"
                    },
                  ]
                  this.echarts_2(xAxis, series, 'echart' + index)
                }
              }else if(item.type == '4') {
                if(orgRept.flowRepttype == '1' || orgRept.flowRepttype == '2') {
                  this.$http.get(url.getOrgRept, {params: {
                    cfFlowReptId: item.cforgreptId,
                  }}).then(res => {
                    if(res.data.code == 200) {
                      let series = res.data.data.map(val => {
                        let obj = val.list.find(el => el.cfFlowReptcontId == orgRept.cfFlowReptcontList[0].cfFlowReptcontId)
                        return {
                          name: val.name,
                          value: obj ? obj.reptValue : ''
                        }
                      })
                      // let series = orgRept.cfFlowReptcontList.map(val => {
                      //   return {
                      //     name: val.label,
                      //     value: 23
                      //   }
                      // })
                      this.echarts_4(series, 'echart' + index)
                    }
                  })
                }else {
                  let series = [
                    { value: 1048, name: '华为' },
                    { value: 735, name: '百度' },
                    { value: 580, name: '拼多多' },
                    { value: 484, name: '小米' },
                    { value: 300, name: 'oppo' }
                  ]
                  this.echarts_4(series, 'echart' + index)
                }
              }
              // item.cfFlowReptcontList = []

            })
          }
        })
      },

      getData(item, tableData) {
        let arr = []
        // console.log(tableData);
        tableData.forEach(val => {
          let obj = val.list.find(el => el.cfFlowReptcontId == item.cfFlowReptcontId)
          if(obj) {
            arr.push(obj.reptValue)
          }else {
             arr.push('')
          }
        })
        return arr
      },
      // 柱状
      echarts_1(xAxis, series, echart) {
        var myChart = echarts.init(document.getElementById(echart));
        let option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            top: "5%",
            left: "1%",
            // textStyle: {
            //   color: "#fff",
            // },
            icon: "roundRect",
          },
          xAxis: {
            type: 'category',
            data: xAxis,
            axisLabel: {
              show: true,
              // textStyle: {
              //   color: "#fff",
              // },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              // textStyle: {
              //   color: "#fff",
              // },
            },
          },
          grid:{
            // height: '60%',

            left: "3%",
            right: "6%",
            bottom: "3%",
            top: "80",
            containLabel: true,
          },
          series: series,
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar', 'stack'] },
              restore: { show: true },
              saveAsImage: { show: true }
            }
          },
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
        // }

      },
      echarts_2(xAxis, series, echart) {
        // console.log(echart);
        // 基于准备好的dom，初始化echarts实例
        // var myEchart = document.getElementsByClassName('echart');
        var myChart = echarts.init(document.getElementById(echart));
        // console.log(myEchart);
        // for(var i = 0; i < myEchart.length; i++) {
        //   var myChart = echarts.init(myEchart[i]);
        let option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            top: "5%",
            left: "1%",
            // textStyle: {
            //   color: "#fff",
            // },
            icon: "roundRect",
          },
          // color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de"],
          grid: {
            left: "3%",
            right: "6%",
            bottom: "3%",
            top: "80",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: xAxis,

            axisLabel: {
              show: true,
              // textStyle: {
              //   color: "#fff",
              // },
            },
          },
          yAxis: {
            type: "value",

            axisLabel: {
              show: true,
              // textStyle: {
              //   color: "#fff",
              // },
            },
          },
          series: series
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
        // }

      },
      echarts_4(series, echart) {
        var myChart = echarts.init(document.getElementById(echart));
        let option = {
          // title: {
          //   text: 'Referer of a Website',
          //   subtext: 'Fake Data',
          //   left: 'center',
          // },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            top: "5%",
            left: "1%",
            // textStyle: {
            //   color: "#fff",
            // },
          },
          series: [
            {
              // name: 'Access From',
              type: 'pie',
              radius: '50%',
              left: "left",
              center: ['60%', `center`],
              radius: ["40%", "80%"],
              data: series,
              label: {
                show: false,
                position: 'center'
              },
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
        // }

      },
      goMessage() {
        JSON.parse(sessionStorage.getItem('menuList')).forEach(el => {
          if(el.label == '我的') {
            this.$router.push({path: el.path})
            this.$store.commit('setSecondMenu', el.children)
            this.$store.commit('selectMenu', el)

            this.$store.commit("setMineData", {isMsg: true})
          }
        })
      },
      viewMore(item) {
        this.$http.get(url.getMsg, {params: {id: item.id}}).then(res => {
          this.$eventBus.$emit('getMsgCount', true)
        })
        if(item.msgType == '1') { // 审批消息
          // if(item.msgTitle.indexOf('待') != -1) {
          //   this.$router.push(this.appList[0].path)
          //   this.$store.commit('selectMenu1', this.appList[0])
          // }else if(item.msgTitle.indexOf('完成') != -1) {
          //   this.$router.push(this.appList[1].path)
          //   this.$store.commit('selectMenu1', this.appList[1])
          // }else if(item.msgTitle.indexOf('抄送') != -1) {
          //   this.$router.push(this.appList[3].path)
          //   this.$store.commit('selectMenu1', this.appList[3])
          // }else {
          //   this.$router.push(this.appList[2].path)
          //   this.$store.commit('selectMenu1', this.appList[2])
          // }
          // this.$router.push('/process/approval')
          // JSON.parse(sessionStorage.getItem('menuList')).forEach(el => {
          //   if(el.label == '审批') {
          //     this.$router.push({path: el.path})
          //     this.$store.commit('setSecondMenu', el.children)
          //     this.$store.commit('selectMenu', el)
          //   }
          // })
          this.$http.get(url.msgJumpInfo, {params: {
              msgId: item.id
            }}).then(res => {
            if(res.data.code == 200) {
              this.$router.push({
                path: '/project/' + res.data.data.ofoItemId,
              });
              this.data = res.data.data
              this.$store.commit("setJumpData", {...res.data.data, isApp: true})
              let obj = {
                path: "/project/" + res.data.data.ofoItemId,
                name: "proDetail",
                label: "项目详情",
                ofoItemId: res.data.data.ofoItemId,
                children: []
              };
              this.menuList.forEach(el => {
                if(obj.path.indexOf(el.path) != -1) {
                  this.$store.commit('setSecondMenu', el.children)
                }
              });
              this.$store.commit("selectMenu", obj);
            }
          })
        }else if(item.msgType == '2') { // 分享消息
          this.$router.push({path: '/share'})
          this.$store.commit('setSecondMenu', [])
          this.$store.commit('selectMenu', {
            children: [],
            class: "icon icon7",
            icon: "iconfont icon-fenxianggeiwo",
            label: "分享给我",
            name: "share",
            path: "/share"
          })
        }else if(item.msgType == '3' && item.msgBussId) { // 协同消息
          this.$http.get(url.getMsgJump, {params: {
            msgBussId: item.msgBussId
          }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit("setJumpData", {...res.data.data, isNotice: true})
              this.$router.push({
                path: '/project/' + res.data.data.ofoItemId,
              });
              let obj = {
                path: "/project/" + res.data.data.ofoItemId,
                name: "proDetail",
                label: "项目详情",
                ofoItemId: res.data.data.ofoItemId,
                children: []
              };
              this.$store.commit('setSecondMenu', [])
              this.$store.commit("selectMenu", obj);
            }
          })
        }else if(item.msgType == '4' && item.msgBussId) { // 预警消息
          this.$http.get(url.getWorkJumpId, {params: {ofoWorkId: item.msgBussId}}).then(res => {
            // console.log(res);
            if(res.data.code == 200) {
              this.$router.push({
                path: '/project/' + res.data.data.ofoItemId,
              });
              this.$store.commit("setJumpData", {...res.data.data, turn: true})
              let obj = {
                path: "/project/" + res.data.data.ofoItemId,
                name: "proDetail",
                label: "项目详情",
                ofoItemId: res.data.data.ofoItemId,
                children: []
              };
              this.$store.commit('setSecondMenu', [])
              this.$store.commit("selectMenu", obj);
            }
          })
        } else if (item.msgType == '4' && !item.msgBussId) {
          this.$message.error(item.msgContent)
        } else {
          JSON.parse(sessionStorage.getItem('menuList')).forEach(el => {
            if(el.label == '个人中心') {
              this.$router.push({path: el.path})
              this.$store.commit('setSecondMenu', el.children)
              this.$store.commit('selectMenu', el)
            }
          })
        }
      },
      // 获取交易
      getFlowMenuList() {
        this.$http.get(url.getFlowMenuList, {params: {
          itemType: '2'
        }}).then(res => {
          if(res.data.code == 200) {
            this.ofoFlowDealList = res.data.data
            if(this.ofoFlowDealList.length) {
              this.activeName = String(this.ofoFlowDealList[0].ofoDealId)
              if(this.ofoFlowDealList[0].ofoFlowWorkList) {
                this.ofoFlowWorkList = this.ofoFlowDealList[0].ofoFlowWorkList
              }
            }

          }
        })
      },
      // 切换tab
      handleClick(tab, event) {
        if(this.ofoFlowDealList[tab.index].ofoFlowWorkList.length) {
          this.ofoFlowWorkList = this.ofoFlowDealList[tab.index].ofoFlowWorkList
        }else {
          this.ofoFlowWorkList = []
        }
      },
      // onresize() {
      //   window.onresize = function () {
      //     myChart1.resize();
      //     myChart.resize();
      //   };
      // },
      turn(item) {
        if(item.name != 'warn') {
          this.$router.push(item.path)
          if(item.name == 'top') {
            let obj = JSON.parse(JSON.stringify(item))
            obj.label = '运营'
            this.$store.commit('selectMenu1', obj)
          }else {
            this.$store.commit('selectMenu1', item)
          }

        }else {
          this.$eventBus.$emit('warnMsg', 111)
        }

      },
      turn2(item,index) {
        let obj =
        {
            label: item.labels[index],
            path: item.paths[index],
            badge: item.badges[index],
            name: item.names[index],
            class: 'icon icon7',
            icon: 'iconfont icon-fenxianggeiwo',
            children: []
          };
          this.$router.push(obj.path)
        this.$store.commit('selectMenu1', obj)
      },
      turnWork(ofoFlowDeal, ofoFlowWork) {
        let obj = {
          path: '/work',
          name: 'work',
          label: '活动',
          children: [],
          ofoFlowDeal,
          ofoFlowWork
        }
        this.$router.push(obj.path)
        this.$store.commit('selectMenu', obj)
      },
      submit() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.$http.post(url.resetPwd, qs.stringify(this.userForm)).then(res => {
              if(res.data.code == 200) {
                this.$message.success(res.data.msg)
                sessionStorage.clear()
                setTimeout(() => {
                  this.$router.push('/');
                  this.$store.commit('changeMenu',{
                    children: [],
                    icon: "iconfont icon-gongzuotai",
                    label: "桌面",
                    name: "index",
                    path: "/index"
                  })
                  this.$store.commit('setSecondMenu', [])
                }, 30);
              }
            })
          }
        });
      },
    },
    mounted() {
      if(this.$route.params.resetPwd) {
        this.dialogFormVisible = true
      }
    }
  }
</script>

<style scoped lang="scss">
.home {
  padding: 16px;

  .box {
    display: flex;
    .box-left {
      flex: 1;
      .back {
        height: 130px;
        display: flex;
        flex-direction: column;
        /* align-items: flex-end; */
        padding-left: 140px;
        font-weight: 600;
        font-size: 20px;
        /* padding-top: 45px; */
        box-sizing: border-box;
        /* background: url(@/assets/images/daiwoshenpi.png); */
      }
    }
    .box-right {
      width: 300px;
      margin-left: 10px;
      padding: 0 !important;
      .box-top {
        height: 80px;
        background: url(@/assets/images/bg.jpg) 100% 100%;
        background-size: cover;
        display: flex;
        align-items: center;
      }
      .box-bottom {
        padding: 10px;
        .title {
          margin: 0;
        }
        .message {
          display: flex;
          align-items: center;
          justify-content: space-between;
          /* background-color: pink; */
          padding: 12px 0 12px 8px;
          border-bottom: #dddddd 1px solid;
          position: relative;
          cursor: pointer;
          .left {
            width: calc(100% - 78px);
            margin-right: 8px;
            .title1 {
              color: #999999;
              width: 100%;
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
            }
            .time {
              color: #aaaaaa;
              font-size: 12px;
              margin-top: 5px;
            }
          }
          .right {
            width: 70px;
          }
          /* .bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 5px;
          } */
          .dot {
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: red;
            top: 20px;
            left: -5px;
          }
        }
      }
    }
  }

  .pro {
    overflow: hidden;
    padding: 16px;
    background-color: #fff;
    margin-bottom: 16px;
    border-radius: 11px;
    .main {
      /* padding: 20px; */
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      ::v-deep .el-table{
        .el-table__body {
          // 吸底
          .fixed-row{
            /* display: inline-block; */
            position: sticky;
            bottom: 0;
            width: 100%;
            background: #f5f7fa;
          }
        }
      }
      .box {
        width: 33%;
        height: 300px;
        /* border: 1px solid #242f67; */
        border-radius: 10px;
        /* background-color: rgba(0, 0, 0, 0.5); */
        /* overflow: auto; */
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        margin-bottom: 20px;
        .tit {
          display: flex;
          align-items: flex-end;
          span {
            background: url(@/assets/images/screen/line1.png) no-repeat bottom right;
            white-space: nowrap;
            padding-bottom: 10px;
            padding-right: 20px;
            font-size: 20px;
            /* color: #fff; */
          }
          p {
            background: url(@/assets/images/screen/line2.png) no-repeat bottom right;
            width: 100%;
            height: 13px;
            margin-bottom: 5px;
            opacity: 0.5;
          }
        }
        .flex {
          flex: 1;
          overflow: auto;
          /* padding: 10px; */
        }
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
          /* background-color: #f19944; */
          color: #000;
        }
        ::v-deep .el-table__empty-block {

          color: #fff;
          background: rgba(0, 0, 0, 0.9);
          .el-table__empty-text {
            color: #fff;
          }
        }
      }
    }
    .el-row {
      width: 100%;
      /* margin: 0 !important; */
    }
    .el-col {

      margin-bottom: 16px;
      .grid-content {
        background: #fff;
        padding: 10px 16px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        /* justify-content: space-between; */
        font-size: 20px;
        .grid-left {
          display: flex;
          align-items: center;
          margin-right: 16px;
        }
        .icon {
          margin-right: 16px;
          /* color: #fff;
          background-color: #0C75E5;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 5px; */
          >i {
            font-size: 38px;
          }

        }
        .icon-daiban {
          background: -webkit-linear-gradient(bottom right,#f16d17, #fad8c8);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-wofaqide1 {
          background: -webkit-linear-gradient(bottom right,#765fe5, #ddd8f6);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-ziyuan200 {
          background: -webkit-linear-gradient(bottom right,#3bcc51, #def4da);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-xiangmu1 {
          background: -webkit-linear-gradient(bottom right,#3ba9f1, #d8eefe);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-gongzuoliuchengtu {
          background: -webkit-linear-gradient(bottom right,#fc6089, #ffe6ed);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-ziyuanzhongxin {
          background: -webkit-linear-gradient(bottom right,#27bc9f, #dffefa);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-yiwancheng-yiban-02 {
          background: -webkit-linear-gradient(bottom right,#3d84ec, #e3f9ff);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-hanhan-01-01 {
          background: -webkit-linear-gradient(bottom right,#ffdb0f, #f0f0ee);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-guanlizhongxin {
          background: -webkit-linear-gradient(bottom right,#0fffb3, #eff0ee);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-fenxianggeiwo {
          background: -webkit-linear-gradient(bottom right,#0f9fff, #eeeff0);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-yujing {
          background: -webkit-linear-gradient(bottom right,#ff0f0f, #f0eeee);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-zhidingmian {
          background: -webkit-linear-gradient(bottom right,#765fe5, #ddd8f6);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .grid-right {
          font-size: 28px;
        }
        .grid-right2 {
          font-size: 24px;
          margin-left: 5px;
        }
      }
    }
    /* >li {
      list-style: none;
      width: calc(25% - 12px);
      width: 260px;
      height: 8vw;
      background-color: #fff;
      padding: 0 30px;
      box-sizing: border-box;
      float: left;
      margin-right: 16px;
      margin-bottom: 16px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;
      .icon {
        width: 6vh;
        height: 6vh;
        padding: 12px;
        border-radius: 50%;
        line-height: 6vh;
        text-align: center;
        margin-right: 16px;
        > i{
          font-size: 38px;
        }
        .icon-daiban {
          background: -webkit-linear-gradient(bottom right,#f16d17, #fad8c8);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-wofaqide1 {
          background: -webkit-linear-gradient(bottom right,#765fe5, #ddd8f6);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-ziyuan200 {
          background: -webkit-linear-gradient(bottom right,#3bcc51, #def4da);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-xiangmu1 {
          background: -webkit-linear-gradient(bottom right,#3ba9f1, #d8eefe);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-gongzuoliuchengtu {
          background: -webkit-linear-gradient(bottom right,#fc6089, #ffe6ed);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-ziyuanzhongxin {
          background: -webkit-linear-gradient(bottom right,#27bc9f, #dffefa);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-fenxianggeiwo {
          background: -webkit-linear-gradient(bottom right,#3d84ec, #e3f9ff);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .icon-hanhan-01-01 {
          background: -webkit-linear-gradient(bottom right,#ffdb0f, #f0f0ee);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      } */
      /* .icon1 {
        background-color: #f3782b !important;
      }
      .icon2 {
        background-color: #7965fd !important;
      }
      .icon3 {
        background-color: #41fd28 !important;
      }
      .icon4 {
        background-color: #51b2fb !important;
      }
      .icon5 {
        background-color: #ff6782 !important;
      }
      .icon6 {
        background-color: #63f9e0 !important;
      }
      .icon7 {
        background-color: #5ec0f5 !important;
      }
      .icon8 {
        background-color: #f9f94f !important;
      } */
      /* >b {
        font-size: 20px;
      }
      > span {
        font-size: 30px;
        position: absolute;
        right: 30px;
      }
    } */
    .no-margin {
      margin-right: 0;
    }
  }
  .echarts {
    height: 300px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    .item {
      width: calc(50% - 40px);
      background-color: #fff;
      border-radius: 11px;
      padding: 16px;
      #stats, #analyse{
        height: calc(100% - 30px);
      }
    }
  }
  .progress {
    overflow: hidden;
    width: 100%;
    background-color: #fff;
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,0.5);
    border-radius: 11px;
    padding: 16px;
    box-sizing: border-box;
    ::v-deep .cell {
      padding-left: 16px;
      padding-right: 0;
    }
    ::v-deep .el-table_9_column_64 {
      padding-left: 50px;
    }
    ::v-deep .el-table thead {
      color: #282828;
      background-color: #ddd;
      >tr {
        background-color: #ddd;
      }
    }
    .el-button {
      border: 0;
      color: #0C75E5;
      padding: 0;
    }
     ::v-deep .el-table__row--striped .el-button{
      background-color: #F9F9FB;
     }
  }
  .title {
    height: 14px;
    font-size: 14px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 15px;
    padding-left: 8px;
    border-left: #0C75E5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
  }
}
.el-divider--horizontal{
  margin: 5px 0 !important;
}
</style>
